import {Injectable, EventEmitter} from '@angular/core';
import {Store} from '@ngrx/store';

// Services
import {AppCatalogService} from '../../catalog/shared/services/app-catalog-service';

// Classes
import {Product} from '../../catalog/shared/classes/product';

// State
import {AppState} from '../state/interfaces/app-state';
import {
    DISPLAY_NAVIGATION_MENU,
    HIDE_NAVIGATION_MENU,
    DISPLAY_START_ARROW,
    HIDE_START_ARROW,
    DISPLAY_PRODUCT_DETAILS_MODAL,
    HIDE_PRODUCT_DETAILS_MODAL,
    DISPLAY_PRINT_SUMMARY_MODAL,
    HIDE_PRINT_SUMMARY_MODAL,
    DISPLAY_EMAIL_SUMMARY_MODAL,
    DISPLAY_ALERT_MODAL,
    HIDE_ALERT_MODAL,
    HIDE_EMAIL_SUMMARY_MODAL,
    DISPLAY_ONLY_DROPDOWN,
    DISPLAY_ALL_CONTENT,
    DISPLAY_OPTIONS_MENU,
    HIDE_OPTIONS_MENU,
    DISPLAY_PREVIEW,
    HIDE_PREVIEW
} from '../state/app-actions';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:AppService'));

/**
 * App service controls all the actions in the application and also the state store.
 * Directly connected to the state store.
 * <!> Current implementation of Ngrx is really poorly done. I was learning at that time.
 *     - Services should not cache values received from the store.
 *     - The components should use them straight away using observables.
 *     - To make life easier those observables could implement some basic selectors.
 *     - Actions should be all returned via constructor methods instead of importing them all here.
 *     - Services should have wrapper methods for calling endpoints.
 *     - Endpoints should be called via Effects and the responese should be stored in state store.
 *     - Observables could be used to do some basic data massaging before passing the data to components.
 * <!> I can provide guidelines on how to do a proper implementation, in the meantime I have mastered the subject.
 *     Unfortunately I do not have the time required to implement it myself.
 */
@Injectable()
export class AppService {

    public selectedProduct: any;
    public generatorCfg: any;
    public roomDimensions: any;

    public state = {
        app: null,
        catalog: null,
        router: null,
        prodOptionsDropdownIsOpened: false,
        spaFrameIsVisible: false,
        standardGeneratorIsVisible: false,
        selectedControl: null, // TODO: Display spaFrame also for previewd controls
    };

    public events = {
        previewVisibilityChanged: new EventEmitter() // TODO: Connect directly to store state, not to actions
    };

    
    constructor (
        private _store: Store<AppState>,
        private _appCatalogService: AppCatalogService
    ) {
        // 'Construct app service' );
        this._subscribeToAppStateChanges();
        this._appCatalogService.init( this );
    }

    // TODO: Refactor
    public selectProduct (product: Product) {
        this.selectedProduct = product;
    }

    
    public init () {
        // 'Initialise app service' );

        let self = this;

        // Load catalog data async
        this._appCatalogService.getCatalogDataAsync();

        // Display start arrow ONLY on first app load
        window.setTimeout( () =>
            self.state.app.startArrowIsOpened === false && self.displayStartArrow()
        , 2000);
    }

    /**
     * <!> This is improper implementation of ngrx store. Caching should not be used. Components should use the information straight away via observables. This implementation was done with insufficient experience at that time. Please contact the original author for guidelines.
     */
    private _subscribeToAppStateChanges () {
        // 'Subscribe to state changes' );

        let self = this;

        // Get state observers
        let catalogState = this._store.select( 'catalog' ),
            appState = this._store.select( 'app' ),
            routerState = this._store.select( 'router' );

        // Subscribe to state store changes
        catalogState.subscribe(
            response => self.state.catalog = response
        );
        appState.subscribe(
            response => self.state.app = response
        );
        routerState.subscribe(
            response => self.state.router = response
        );

        // 'App state:', this.state );
    }

    
    public toggleNavigationMenu () {
        debugOff( 'Toggle navigation menu' );
        if (this.state.app.navigationMenuIsVisible === true) {
            this.hideNavigationMenu();
        } else {
            this.displayNavigationMenu();
        }
    }

    
    public displayNavigationMenu () {
        if (this.state.app.navigationMenuIsVisible === false) {
            debugOff('Display navigation menu');
            this._store.dispatch({type: DISPLAY_NAVIGATION_MENU});
        }
    }

    
    public hideNavigationMenu () {
        if (this.state.app.navigationMenuIsVisible === true) {
            debugOff( 'Hide navigation menu' );
            this._store.dispatch({ type: HIDE_NAVIGATION_MENU });
        }
    }

    
    public displayStartArrow () {
        if (this.state.app.startArrowIsVisible === false) {
        debugOff( 'Display start arrow' );
            this._store.dispatch({type: DISPLAY_START_ARROW});
        }
    }

    
    public hideStartArrow () {
        if (this.state.app.startArrowIsVisible === true) {
        debugOff( 'Hide start arrow' );
            this._store.dispatch({ type: HIDE_START_ARROW });
        }
    }

    
    public displayProductDetailsModal (product: Product) {
        if (this.state.app.productDetailsModalIsVisible === false) {
            debugOff('Display product details modal');
            product && (this.selectedProduct = product);
            this._store.dispatch({type: DISPLAY_PRODUCT_DETAILS_MODAL});
        }
    }

    
    public hideProductDetailsModal () {
        if (this.state.app.productDetailsModalIsVisible === true) {
            debugOff('Hide product details modal');
            this._store.dispatch({type: HIDE_PRODUCT_DETAILS_MODAL});
        }
    }

    
    public displayPrintSummaryModal () {
        if (this.state.app.printSummaryModalIsVisible === false) {
            debugOff('Display print summary modal');
            this._store.dispatch({type: DISPLAY_PRINT_SUMMARY_MODAL});
        }
    }

    
    public hidePrintSummaryModal () {
        if (this.state.app.printSummaryModalIsVisible === true) {
            debugOff('Hide print summary modal');
            this._store.dispatch({type: HIDE_PRINT_SUMMARY_MODAL});
        }
    }

    
    public displayEmailSummaryModal () {
        if (this.state.app.emailSummaryModalIsVisible === false) {
            debugOff('Display email summary modal');
            this._store.dispatch({type: DISPLAY_EMAIL_SUMMARY_MODAL});
        }
    }

    
    public hideEmailSummaryModal () {
        if (this.state.app.emailSummaryModalIsVisible === true) {
            debugOff('Hide email summary modal');
            this._store.dispatch({type: HIDE_EMAIL_SUMMARY_MODAL});
        }
    }

        public displayAlertModal () {
        if (this.state.app.alertModalIsVisible === false) {
            debugOff('Display email summary modal');
            this._store.dispatch({type: DISPLAY_ALERT_MODAL});
        }
    }

    
    public hideAlertModal () {
        if (this.state.app.alertModalIsVisible === true) {
            debugOff('Hide email summary modal');
            this._store.dispatch({type: HIDE_ALERT_MODAL});
        }
    }

    
    public displayOnlyDropdown () {
        if (this.state.app.onlyDropdownIsVisible === false) {
            debugOff('Display only dropdown');
            this._store.dispatch({type: DISPLAY_ONLY_DROPDOWN});
        }
    }

    
    public displayAllContent () {
        if (this.state.app.onlyDropdownIsVisible === true) {
            debugOff('Display all content');
            this._store.dispatch({type: DISPLAY_ALL_CONTENT});
        }
    }

    
    public displayOptionsMenu () {
        if (this.state.app.optionsMenuIsVisible === false) {
            debugOff('Display options menu');
            this._store.dispatch({type: DISPLAY_OPTIONS_MENU});
        }
    }

    
    public hideOptionsMenu () {
        if (this.state.app.optionsMenuIsVisible === true) {
            debugOff('Hide options menu');
            this._store.dispatch({type: HIDE_OPTIONS_MENU});
        }
    }

    
    public togglePreview () {
        debugOff( 'Toggle preview' );
        if (this.state.app.previewIsVisible === true) {
            this.hidePreview();
        } else {
            this.displayPreview();
        }
    }

    
    public displayPreview () {
        if (this.state.app.previewIsVisible === false) {
            debugOff('Display preview');
            this._store.dispatch({type: DISPLAY_PREVIEW});
            this.events.previewVisibilityChanged.emit( true ); // Change to object event {}
        }
    }

    
    public hidePreview () {
        if (this.state.app.previewIsVisible === true) {
            debugOff('Hide preview');
            this._store.dispatch({type: HIDE_PREVIEW});
            this.events.previewVisibilityChanged.emit( false );
        }
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/shared/services/app-service.ts